import { render, staticRenderFns } from "./SoftUpgrade.vue?vue&type=template&id=71d4faba&scoped=true"
import script from "./SoftUpgrade.vue?vue&type=script&lang=js"
export * from "./SoftUpgrade.vue?vue&type=script&lang=js"
import style0 from "./SoftUpgrade.vue?vue&type=style&index=0&id=71d4faba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d4faba",
  null
  
)

export default component.exports